import React from "react";
// import HttpService from '../utils/Http.services';
// import { siteConfig, siteTheme } from "../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../components/Configurer";
import Dashboard from "./profile/Dashboard";
import StagesManager from "../components/StagesManager";
import { checkTranslation, pathMaker, translate } from "../utils/useful";
import Cookies from "universal-cookie";
import PageStatusViewer from "../components/PageStatusViewer";
import AccountType from "./profile/AccountType";
import Financial from "./profile/Financial";
import Modal from "../components/Modal";
import Addresses from "./profile/Financial";
import Wallet from "./profile/Wallet";
import EditProfile from "./profile/EditProfile";
import ChangePasword from "./profile/ChangePasword";
import TLink from "../components/TLink";
// import { logoutUser } from "../stores/actionsList";


class Profile extends React.Component {

    state = {
        pages: [
            { name: '{{lang}}Profile', icon: '/images/icons/user-black.png', key: '', dontShowInDashboard: true },
            { name: '{{lang}}Edit Profile', icon: '/images/icons/pencil.png', key: 'edit' },
            // { name: 'Financial', icon: '/images/benefit.svg', key: 'financial' },


            // { name: 'Wallet', icon: '/images/wallet.svg', key: 'wallet' },

            // { name: 'Addresses', icon: '/images/placeholder.svg', key: 'addresses' },

            // { name: 'Account type', icon: 'https://www.flaticon.com/svg/static/icons/svg/744/744922.svg', key: 'type' },
            { name: '{{lang}}Change Password', icon: '/images/icons/key.png', key: 'password' },


        ]
    }


    componentDidMount() {

        const cookies = new Cookies();
        let token = cookies.get('admintoken');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
        }

        // setInterval(() => {
        //     // console.log("HERE")
        //     if(this.configurer){
        //         console.log(this.configurer)
        //         console.log(this.configurer.props.settingsInfo)
        //     }
        // }, 2000);

        // if(this.configurer){
        //     console.log(this.configurer)
        //     console.log(this.configurer.settingsInfo)
        // }
    }


    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            this.setState({ isLoading: false }, () => {
                this.checkDefaultTab()
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    // this.props.actions.logoutUser()
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }


    componentDidUpdate(newProps) {
        let windowPath = this.props.location.pathname.split('/')
        windowPath = windowPath[windowPath.length - 1]

        // console.log(windowPath)
        // console.log(this.state.path)
        if (this.state.oldPath && this.state.oldPath != this.props.location.pathname) {
            // console.log("CHANGEEEEE")
            this.setState({ oldPath: this.props.location.pathname }, () => {
                this.checkDefaultTab()
            })
        }
    }



    checkDefaultTab() {

        let def = ''

        let pathname = window.location.pathname.split('/')
        pathname.forEach((path, index) => {
            // console.log(path)
            if (path == 'profile') {
                def = pathname[index + 1]
            }
        });

        let pageIsValid = false

        this.state.pages.forEach(tab => {
            if (tab.key.toLowerCase() === def?.toLowerCase()) {
                pageIsValid = true
            }
        });
        if (!def) {
            def = ''
        }
        // console.log(def)
        if (pageIsValid || def === '') {
            this.setState({ oldPath: this.props.location.pathname, pageStatus: 200 }, () => {
                this.setState({ path: def, }, () => {
                    this.stageManager.changeStage(def, () => {
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                    })
                })

                // this.changePage(def)
                // if (def == '' || !def) {
                // this.stageManager.changeStage('dashboard')
                // this.stageManager.changeStage(def)
                // // this.props.history.push(pathMaker('/profile'))
                // } else {

                //     this.stageManager.changeStage(def)

                // }
            })
        } else {
            this.setState({ pageStatus: 404 })
        }
    }








    changePage = (page) => {

        let path = [...this.props.baseUrl, page]

        path = pathMaker(path.join('/'))


        // console.log("CHANGE PAGE")
        // this.stageManager.changeStage(page)
        // this.stageManager.changeStage(page, () => {
        //     // window.scrollTo(0, 0)
        // })
        // let path = pathMaker('/profile/' + page)
        // if (this.props.history.pathname != path) {
        //     this.setState({ path: page }, () => {
        //         // console.log("PUSHHHHH")
        this.props.history.push(path)
        if (this.mobileMenuModal) {
            this.mobileMenuModal.hideModal()
        }
        // })
        // }

        // console.log(path)
        // window.history.pushState(null, null, path);

    }


    setUser = (data) => {
        this.props.actions.setUser(data, null, true)
    }


    addNotif = (options) => {
        this.props.actions.addNotif(options)
    }

    logoutAlert = () => {
        this.logoutModal.showModal()
    }

    logout = () => {
        this.props.actions.logoutUser()
        // this.props.history.push(pathMaker('/login'))
        window.history.pushState(null, null, pathMaker('/login'));

        this.logoutModal.hideModal()
    }

    openMobileMenu = () => {
        this.mobileMenuModal.showModal()
    }

    showMenu() {
        return (
            <div>
                <div style={{ background: '#f2f6f8', borderRadius: "10px" }} className="text-center py-3 mb-3">
                    <div className="mx-3  p-2 flexcc flex-column">
                        <img src="/images/male.png " width="90px" style={{ borderRadius: 100, width: 50 }} />
                        <div className="mld-2">
                            <p className="mt-2" style={{ fontSize: "17px", fontWeight: "400" }}>{this.props.user?.info?.name} {this.props.user?.info?.family}</p>
                            {/* <p className=" " style={{ fontSize: "14px", fontWeight: "400", color: "gray" }} >{translate("@Username")}</p> */}
                        </div>
                    </div>

                    {/* <p className="text-small">Account type</p> */}
                    <button onClick={() => this.logoutAlert()} className="px-3 py-2 mx-auto d-flex" style={{ borderRadius: 20, background: 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))', padding: '0px 30px', }}>
                        <p className="pl-2" style={{ color: '#fff', fontSize: "14px", fontWeight: "400" }}>{translate("Log out")}</p>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#fff" class="" style={{ width: 22 }}>
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
                        </svg>

                    </button>
                </div>

                {/* 
                <button onClick={() => this.changePage('wallet')} className="text-center py-3 px-2 w-100" style={{ backgroundColor: '#F87C5630', borderRadius: 2 }}>
                    <p className="text-bold text-normal" style={{ color: '#F87C56' }}>{this.props.user?.info?.balance ?? 0} Coins</p>
                    <p className="text-smaller text-uppercase text-bold " style={{ color: '#345' }}>Your Balance</p>
                </button> */}

                <div className="">
                    {this.state.pages.map((prop, index) => {

                        let link = [...this.props.baseUrl]
                        if (prop.key && prop.key != '') {
                            link.push(prop.key)
                        }

                        return (
                            <div className="">
                                <TLink className={"pageSideOption flexc " + (prop.key == this.state.path ? "selected" : '')} to={link.join('/')}>

                                    {/* <button onClick={() => this.changePage(prop.key)} key={index} className={"pageSideOption flexc " + (prop.key == this.state.path ? "selected" : '')}> */}
                                    <img src={prop.icon} width="15px" className="mrd-3" alt="" />
                                    <p>{checkTranslation(prop.name)}</p>
                                    {/* </button> */}
                                </TLink>
                            </div>
                        )
                    })}
                </div>

            </div>
        )
    }


    render() {

        return (

            <Configurer
                settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: "Profile", button: {} }}
                title={"Profile"}
                description={"Profile Description"}
                className="p-0 min-full-height"
                ref={el => this.configurer = el}
            >

                <PageStatusViewer status={this.state.pageStatus}>


                    <div className="p-3">
                        <div className="row m-0">

                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-2 pageSide px-0 d-md-block d-none" style={{ backgroundColor: "#fff", borderRadius: '20px' }} >
                                {this.showMenu()}
                            </div>


                            <Modal ref={el => this.mobileMenuModal = el} maxWidth={300}>
                                <div className="pageSide" style={{ backgroundColor: '#fff', borderRadius: 15, padding: '20px 5px 70px 5px' }}>
                                    {this.showMenu()}

                                </div>
                            </Modal>


                            <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-10 p-0" >

                                <StagesManager ref={el => this.stageManager = el} fast={true}>
                                    <Dashboard history={this.props.history} baseUrl={[...this.props.baseUrl]} pages={this.state.pages} stage={0} user={this.props.user} openMobileMenu={this.openMobileMenu} stageName={''} changePage={this.changePage} logoutAlert={this.logoutAlert} />
                                    <EditProfile history={this.props.history} baseUrl={[...this.props.baseUrl]} pages={this.state.pages} stage={1} user={this.props.user} openMobileMenu={this.openMobileMenu} setUser={this.setUser} addNotif={this.addNotif} stageName={'edit'} />
                                    {/* <Financial history={this.props.history}  baseUrl={[...this.props.baseUrl]} pages={this.state.pages} stage={2} user={this.props.user} openMobileMenu={this.openMobileMenu} stageName={'financial'} />
                                <Addresses history={this.props.history}  baseUrl={[...this.props.baseUrl]} pages={this.state.pages} stage={2} user={this.props.user} openMobileMenu={this.openMobileMenu} stageName={'addresses'} /> */}
                                    {/* <Wallet history={this.props.history}  baseUrl={[...this.props.baseUrl]} pages={this.state.pages} stage={2} user={this.props.user} openMobileMenu={this.openMobileMenu} stageName={'wallet'} /> */}

                                    <ChangePasword history={this.props.history} baseUrl={[...this.props.baseUrl]} pages={this.state.pages} stage={3} user={this.props.user} openMobileMenu={this.openMobileMenu} addNotif={this.addNotif} stageName={'password'} />

                                </StagesManager>

                            </div>
                        </div>
                    </div>

                </PageStatusViewer>

                <Modal maxWidth={350} ref={el => this.logoutModal = el}>
                    <div className="text-center" style={{ backgroundColor: '#fff', borderRadius: 8, padding: '30px' }}>
                        <p className="text-big text-bold">خروج از حساب کاربری </p>
                        <p className="text-small">آیا مطمِن هستید میخواید از حساب کاربری خارج شوید؟</p>

                        <div className="flexcc mt-3">
                            <button onClick={() => this.logout()} className="px-5 py-2 mx-2 white text-small" style={{ backgroundColor: '#FF3B30', borderRadius: 30 }}>خروج</button>
                            <button onClick={() => this.logoutModal.hideModal()} className="px-5 mx-2 py-2 text-small" style={{ backgroundColor: '#e2e8f2', borderRadius: 30 }}>لغو</button>
                        </div>

                    </div>
                </Modal>

            </Configurer>
        )


    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Profile);
